import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListRequestLeaveManagerStart,
  getListRequestLeaveManagerSuccess,
  getListRequestLeaveManagerFailed,
} from "../redux/getListRequestLeaveManager";
import { getListRequestLeaveManagerAPI } from "core/http/service/decleareLeave";
import moment from "moment";

function* getListRequestLeaveManagerWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getListRequestLeaveManagerAPI, {
      screenCode,
      ...payload,
    });
    const formattedData = res.data.map((item, index) => ({
      ...item,
      index: index + 1,
      fromDate: moment(item?.fromDate),
      toDate: moment(item?.toDate),
    }));
    yield put({
      type: getListRequestLeaveManagerSuccess.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListRequestLeaveManagerFailed.type,
    });
  }
}

function* watchGetListRequestLeaveManager() {
  yield takeLatest(
    getListRequestLeaveManagerStart.type,
    getListRequestLeaveManagerWork
  );
}

export default function* getListRequestLeaveManagerSaga() {
  yield all([watchGetListRequestLeaveManager()]);
}
